import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, AdsPUTApiToken } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import ImageUpload from "../../../ImageUpload";
import { login } from '../../../../redux/action';
const studentRoles = ["subscriber", "student"]
export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)
  const Login = useSelector((state) => state.LoginState);

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [ProfilePicture, setProfilePicture] = React.useState(FetchData.meta.user_profile_picture)
  const [PhoneNumber, setPhoneNumber] = React.useState(FetchData.meta.user_phone_number)
  const [VerificationStatus, setVerificationStatus] = React.useState(FetchData.meta.verification_status)
  const [userID, setUserID] = React.useState(FetchData.meta.user_id)
  const [userName, setUserName] = React.useState(FetchData.meta.user_name)
  const [Password, setPassword] = React.useState(FetchData.meta.class_code)
  const [userEmail, setUserEmail] = React.useState(FetchData.meta.user_email)
  const [userVerificationHistory, setUserVerificationHistory] = React.useState(FetchData.meta.user_verification_history)

  const [Schedules, setSchedules] = React.useState(FetchData.meta.schedules=="" ? [] : JSON.parse(FetchData.meta.schedules))
  const [SchedulesCache, setSchedulesCache] = React.useState(JSON.parse(FetchData.meta.schedules))
  const [EditCourseGroup, setEditCourseGroup] = React.useState(false)
  const [ShowCourseGroupList, setShowCourseGroupList] = React.useState(true)
  const [CourseGroupChoosen, setCourseGroupChoosen] = React.useState("All")

  // const [Name, setName] = React.useState(FetchData.title.rendered)
  const dispatch = useDispatch()

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const AfterUserCreate = (id) => {
    const data = {
      "title": userName,
      "status": "publish",
      "author": id,
      "meta": {
        "user_role": "staff",
        "user_profile_picture": ProfilePicture,
        "user_phone_number": PhoneNumber,
        "verification_status": VerificationStatus,
        "user_id": `${id}`,
        "user_name": userName,
        "user_email": userEmail,
        "user_verification_history": userVerificationHistory,
        "batch_id": "",
        "batch_name": "",
        "user_featured_exam": "",
        "user_featured_exam_slug": "",
        "user_featured_exam_main_slug": "paid_exam",
        "number_of_exams": "",
        "class_code": Password,
        "schedules":JSON.stringify(Schedules)
      }
    }
    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_user_data)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Book Added Successfully")
          history.push(`${slugs.tab_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_user_data, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  const EditInfo = () => {
    setReload(true)

    if (ID == "") {
      const dataWithPassword = {
        "username": userName,
        "email": userEmail,
        "password": Password,
        "roles": "staff"
      }
      AdsPOSTApi(dataWithPassword, "users")
        .then(res => {
          AfterUserCreate(res.data.id)
        })
        .catch(e =>
          console.log(e)
        )
    }
    else {
      const dataWithPassword = {
        "password": Password,
        "roles": "tab"
      }
      if (Login.userID !== userID)
        AdsPUTApi(dataWithPassword, `users`, `${userID}`)
          .then(res => {
            AfterUserCreate(userID)
          })
          .catch(e =>
            console.log(e)
          )
      else {
        setAlertShow(true)
        setAlertcomp("You are not allowed to cahnge owns password")
        setReload(false)
      }
    }
  }



  return (
    <div>{console.log(Login)}
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Tab Information </center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Name </td>
                <td className="col-6">
                  <div className="iinput-common">
                    {userName}
                  </div>
                  {/* <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  /> */}
                </td>
              </tr>

              <tr>
                <td className="col-3">Profile Picture</td>
                <td className="col-6">
                  <ImageUpload
                    ImageUrl={ProfilePicture}
                    setImageUrl={setProfilePicture}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Phone Number</td>
                <td className="col-6">
                  <input className="input-common"
                    value={PhoneNumber} placeholder="Phone Number"
                    onChange={(event) => { setPhoneNumber(event.target.value) }}
                  />
                </td>
              </tr>
              {ID == "" &&
                <tr>
                  <td className="col-3">User Name</td>
                  <td className="col-6">
                    <input className="input-common"
                      value={userName} placeholder="User Name"
                      onChange={(event) => { setUserName(event.target.value) }}
                    />
                  </td>
                </tr>
              }

              <tr>
                <td className="col-3">User Email</td>
                <td className="col-6">
                  {ID == "" ?
                    <input className="input-common"
                      value={userEmail} placeholder="User Email"
                      onChange={(event) => { setUserEmail(event.target.value) }}
                    />
                    :
                    <div className="input-common" >{userEmail}</div>
                  }
                </td>
              </tr>
              <tr>
                <td className="col-3">Password</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Password} placeholder="Password"
                    onChange={(event) => { setPassword(event.target.value) }}
                  />

                </td>
              </tr>

            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Teacher
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mb-3">
          <h4><center>Schedules</center></h4>
          {EditCourseGroup ?
            <div className="m-2">
              <div style={{ cursor: "pointer" }} onClick={() => { setEditCourseGroup(false) }}>Done Edit</div>
              {ShowCourseGroupList &&
                <div className="" style={{ padding: "0 10px" }}>
                  {Object.values(Schedules).map((item, index) => (
                    <div key={index} style={{ display: "flex", padding: "3px 0" }}>
                      <span style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</span>
                      <span>
                        <input className="input-common-4"  style={{width:"200px"}}
                          value={item} placeholder="Shift"
                          onChange={(event) => {
                            setSchedules({
                              ...Schedules,
                              [Object.keys(Schedules)[index]]: event.target.value
                            })
                          }}
                        />
                      </span>
                      {Object.values(Schedules).filter(a => a.chapter_type == item).length == 0 &&
                        <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                          var ObjectForDelete = Schedules
                          var key = Object.keys(Schedules)[index]
                          console.log(key, Schedules)
                          delete ObjectForDelete[key];
                          setSchedules(ObjectForDelete)
                          setShowCourseGroupList(false)
                          setTimeout(() => {
                            setShowCourseGroupList(true)
                          }, 10)
                        }}>
                          Delete
                        </span>
                      }
                    </div>
                  ))}
                </div>
              }
              {Schedules[Schedules.length - 1]}
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    var newValue = ""
                    var lastkey = Object.keys(Schedules).length == 0 ? 0 : Number(Object.keys(Schedules)[Object.keys(Schedules).length - 1])
                    console.log(lastkey + 1)
                    var newKey = `${lastkey + 1}`
                    var newObject = Schedules;
                    newObject = {
                      ...Schedules,
                      [newKey]: newValue
                    }
                    console.log(newObject)

                    setSchedules(newObject)
                  }}
                >
                  Add Shift
                </div>
              </div>
            </div>
            :
            <div>
              <div onClick={() => { setEditCourseGroup(true) }} style={{ cursor: "pointer", margin: "10px" }}>Edit</div>
              <div className="row" style={{ margin: "5px 10px" }}>

                {Object.values(Schedules).map((item, index) => (
                  <div className="col-sm-3" key={index} style={{ padding: "10px ", border: "0.5px solid #999" }}>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          }
        </div>
      </div>




      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div >
  )

}